import React from 'react';
import styled from 'styled-components';
import CheckboxField from 'gatsby-theme-core/src/components/form-elements/checkbox/index';
import spacer from 'gatsby-theme-core/src/components/form-elements/spacer';

const isChecked = (currentValue, value) => {
  if (Array.isArray(currentValue)) {
    return currentValue.includes(value);
  }
  return currentValue === value;
};

const Checkbox = ({
  className,
  currentValue = '',
  handler,
  options = [],
  withCount = false,
}) => (
  <div className={className}>
    {options.map(({
      value,
      name,
      Component = null, // for example Energylabel converts names to components
      count,
    }) => {
      const theValue = value || name;
      return (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <Label key={name}>
          <CheckboxField
            checked={isChecked(currentValue, theValue)}
            value={theValue}
            onChange={handler}
            Tag="span"
          />
          <Span>{Component ?? `${name || ''}${(withCount && count) ? ` (${count})` : ''}`}</Span>
        </Label>
      );
    })}
  </div>
);

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: .4rem;

  ${CheckboxField} {
    flex-shrink: 0;
  }
`;

// ::first-letter only works on block elements
const Span = styled.span`
  display: inline-block;
  &::first-letter {
    text-transform: capitalize;
  }
`;

export default styled(Checkbox)`
  ${spacer}
`;
